import { render, staticRenderFns } from "./IconArrowRightAlt.vue?vue&type=template&id=648540c0&"
import script from "./IconArrowRightAlt.vue?vue&type=script&lang=js&"
export * from "./IconArrowRightAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648540c0')) {
      api.createRecord('648540c0', component.options)
    } else {
      api.reload('648540c0', component.options)
    }
    module.hot.accept("./IconArrowRightAlt.vue?vue&type=template&id=648540c0&", function () {
      api.rerender('648540c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconArrowRightAlt.vue"
export default component.exports